<template>
    <a-modal v-model:visible="show"
             loading
             centered
             wrapClassName="buy-dialog"
             :maskClosable="false"
             :title="LAN.common.confirmBuy">
        <a-spin :spinning="loading">
            <div class="n-flex n-flex-a-c n-flex-j-sb">
                <h3 class="n-m-0 n-flex-g n-f-8 n-mr-4 n-c-4 n-flex-s">{{LAN.cart.totalItems1.replace('=COUNT=', data.length).replace('=UNIT=', data.length > 1 ? 's' : '')}}</h3>
                <h3 class="n-m-0 n-flex-s n-f-8 n-text-right n-c-base n-flex-s">{{ data[0].currency + totalPrice }}</h3>
            </div>

            <div class="n-flex-g n-mt-4 payment-element n-skeleton"
                 id="payment-element"></div>

            <div class="n-mt-2">
                <div v-for="(item, index) in data"
                     :key="index"
                     class="n-flex n-flex-a-c n-ptb-3 n-t-line">
                    <div class="n-flex-s n-mr-4">
                        <NImage class="cart-item-image"
                                type="cover"
                                :lazy="false"
                                :zoomView="false"
                                :src="item.coverPicture">
                        </NImage>
                    </div>

                    <div class="n-flex-g n-flex-g-w-1-hack">
                        <h4 class="n-f-bold n-f-10 n-c-4 n-m-0 n-line-height-1">{{ item.title || '-' }}</h4>
                        <p class="n-f-6 n-c-3 n-m-0 n-mt-4">ISBN: {{ item.isbn || '-' }}</p>
                        <p class="n-f-6 n-c-3 n-m-0 n-mt-1">{{LAN.common.publishDate}}: {{ item.publishDate }}</p>
                        <p class="n-f-10 n-f-bold n-c-base n-m-0 n-mt-2">{{LAN.common.salePrice}}: {{item.currency}}{{ item.listPrice }}</p>
                    </div>
                </div>
            </div>
        </a-spin>

        <template #footer>
            <div class="n-flex n-flex-a-c n-flex-j-e">
                <a-button class="c-tab-link c-tab-link-event"
                          @click="$emit('cancel')">{{ LAN.nui.common.cancel }}</a-button>
                <a-button type="primary"
                          class="c-tab-link c-tab-link-event"
                          :disabled="loading"
                          @click="confirmPay">{{ LAN.book.pay }}</a-button>
            </div>
        </template>
    </a-modal>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import NImage from '@/components/nui/NImage/NImage.vue'
    import nui from '@/assets/script';
    import { message } from 'ant-design-vue';


    export default {
        name: 'BookTable',
        props: {
            show: Boolean,
            data: { type: Array, default: () => { } },
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),

            totalPrice () {
                return parseFloat(this.data.reduce((total, item) => {
                    return total + (item.listPrice * (item.quantity || 1));
                }, 0)).toFixed(2);
            },
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                stripe: null,
                elements: null
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.createPay()
            },
            createPay () {
                this.loading = true;

                this.request(this.API.pay, {
                    method: 'post',
                    data: this.data.map(item => {
                        return {
                            objId: item.objId,
                            objType: "BOOK"
                        }
                    })
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.stripe = Stripe(res.data.pk);

                        this.elements = this.stripe.elements({
                            appearance: {
                                theme: 'stripe',
                            },
                            clientSecret: res.data.clientSecret
                        });

                        this.elements.create("payment", {
                            layout: "accordion",
                        }).mount("#payment-element");
                    } else {
                        message.error(res.msg, 3);
                    }

                    this.loading = false
                })
            },
            confirmPay () {
                this.loading = true;

                this.stripe.confirmPayment({
                    elements: this.elements,
                    confirmParams: {
                        return_url: location.protocol + '//' + location.host + "/paid?pid=" + this.data.map(item => item.objId).join(',')
                    },
                }).then((res) => {
                    if (res.error) {
                        console.log(111, res.error);
                    }

                    this.loading = false;
                });
            }
        }),
        components: {
            NImage
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .cart-item-image {
        width: 104px;
        height: 148px;
    }

    .payment-element {
        min-height: 100px;
    }
</style>
<style>
    .buy-dialog .ant-modal {
        width: 1002px !important;
        max-width: calc(100vw - 10px) !important;

        .ant-modal-body {
            max-height: calc(100vh - 210px) !important;
            overflow: auto;
        }

        .ant-modal-title {
            font-size: 24px;
        }
    }
</style>